// closing-misc-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1c.postRef': '(partida {code})',
  'r1c.addSuffix': ' (partida)',
  'r1c.incomeBalanceNote': 'Cambiar las cifras aquí no afecta a tu contabilidad, solo a la declaración de impuestos. Si tu contabilidad es incorrecta, debes reabrir el ejercicio y corregirla antes de crear un nuevo borrador de la declaración de impuestos.',
});
